<script type="text/javascript">
  export default {};
</script>

<template>
  <div class="market-chart-loader">
    <div class="market-chart-loader__sine-wave"></div>
    <div class="market-chart-loader__content">
      <div class="market-chart-loader__text-1"></div>
      <div class="market-chart-loader__text-2"></div>
      <div class="market-chart-loader__text-3"></div>
      <div class="market-chart-loader__text-4"></div>
      <div class="market-chart-loader__text-5"></div>
      <div class="market-chart-loader__text-6"></div>
      <div class="market-chart-loader__text-7"></div>
      <div class="market-chart-loader__text-8"></div>
      <div class="market-chart-loader__text-9"></div>
      <div class="market-chart-loader__text-10"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .market-chart-loader {
    @import '~styles/settings';

    background: $white;
    height: 390px;
    position: relative;

    &__content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      gap: 12px;
    }

    &__text-1 {
      @include text-line(10%, 90%, $blue1);
    }

    &__text-2 {
      @include text-line(10%, 70%, $blue1);
    }
    &__text-3 {
      @include text-line(10%, 50%, $blue1);
    }
    &__text-4 {
      @include text-line(10%, 60%, $blue1);
    }
    &__text-5 {
      @include text-line(10%, 10%, $blue1);
    }
    &__text-6 {
      @include text-line(10%, 2%, $blue1);
    }
    &__text-7 {
      @include text-line(10%, 40%, $blue1);
    }
    &__text-8 {
      @include text-line(10%, 50%, $blue1);
    }
    &__text-9 {
      @include text-line(10%, 35%, $blue1);
    }
    &__text-10 {
      @include text-line(10%, 85%, $blue1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/MarketChartLoader.vue